module.exports = __webpack_public_path__ + "img/img31.8e64629b.jpg";